import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts&setup=true"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=4acbc36d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acbc36d"]])

export default __exports__